import { checkoutHardware, updateAssetTag } from "@/lib/snipeit/hardware";
import { useMutation } from "@tanstack/react-query";
import { useLocation } from "wouter";

export function useCheckoutHardware() {
  const [, navigate] = useLocation();

  return useMutation({
    mutationFn: async ({ assetId, userId, newAssetTag }: { assetId: number; userId: number; newAssetTag?: string }) => {
      await checkoutHardware(assetId, userId);
      if (newAssetTag !== undefined) {
        await updateAssetTag(assetId, newAssetTag);
      }
    },
    onSuccess: () => navigate("/"),
  });
}
